import React, { useState } from "react";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { changePassword } from "../api/user";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleTogglePassword = (field) => {
    switch (field) {
      case "old":
        setShowOldPassword(!showOldPassword);
        break;
      case "new":
        setShowNewPassword(!showNewPassword);
        break;
      case "confirm":
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setError("");
    // Assuming oldPassword, newPassword, confirmPassword, setError, email, and password are defined
    // Validate password fields
    if (!oldPassword || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      setIsDisabled(false); // Enable the button if validation fails
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New password & confirm password should be the same.");
      setIsDisabled(false); // Enable the button if validation fails
      return;
    }
    // Assuming login is an asynchronous function that returns a promise
    try {
      const body = {
        old_password: oldPassword,
        password: newPassword,

        // Assuming oldPassword is used for login
      };

      const response = await changePassword(body);

      if (response.data.success && response.data.status === 200) {
        // console.log(response);
        localStorage.clear();
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/auth/login");
          setIsDisabled(false);
          // Handle successful login
        }, 3000); // Handle successful login
      } else if (response.data.status === 400) {
        console.log("400");
        setIsDisabled(false);
        toast.error(response.data.message);

        // Handle login failure
      }
    } catch (error) {
      console.log(error);
      setIsDisabled(false);
      // Handle other errors
    }
  };
  const [sidebarToggle] = useOutletContext();
  const isMobileView = document.body.clientWidth <= 768; // You can adjust the breakpoint as needed

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Change Password")} />
      <PageContainer>
        <div
          className={
            isMobileView
              ? "p-8 mt-4 rounded-2xl border md:mt-4 mt-0 bg-[#FBFCFC] border-white-500 max-w-[55rem] mx-auto"
              : "p-8 rounded-2xl border md:mt-4 mt-0 bg-[#FBFCFC] border-white-500 max-w-[55rem] mx-auto"
          }
        >
          <form onSubmit={handleSubmit}>
            <div className="mb-4 relative">
              <label
                htmlFor="oldPassword"
                className="block text-sm font-medium text-gray-700"
              >
                {t("Old Password")}
              </label>
              <input
                type={showOldPassword ? "text" : "password"}
                id="oldPassword"
                className="mt-1 p-2 w-full border rounded-md"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
              <span
                className="absolute right-2 mt-6 transform -translate-y-1/2 cursor-pointer"
                onClick={() => handleTogglePassword("old")}
              >
                {showOldPassword ? (
                  <FontAwesomeIcon icon={faEye} />
                ) : (
                  <FontAwesomeIcon icon={faEyeSlash} />
                )}
              </span>
            </div>
            <div className="mb-4 relative">
              <label
                htmlFor="newPassword"
                className="block text-sm font-medium text-gray-700"
              >
                {t("New Password")}
              </label>
              <input
                type={showNewPassword ? "text" : "password"}
                id="newPassword"
                className="mt-1 p-2 w-full border rounded-md"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span
                className="absolute right-2  mt-6 transform -translate-y-1/2 cursor-pointer"
                onClick={() => handleTogglePassword("new")}
              >
                {showNewPassword ? (
                  <FontAwesomeIcon icon={faEye} />
                ) : (
                  <FontAwesomeIcon icon={faEyeSlash} />
                )}
              </span>
            </div>
            <div className="mb-4 relative">
              <label
                htmlFor="confirmPassword"
                className="block text-sm font-medium text-gray-700"
              >
                {t("Confirm Password")}
              </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                className="mt-1 p-2 w-full border rounded-md"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span
                className="absolute right-2 mt-6 transform -translate-y-1/2 cursor-pointer"
                onClick={() => handleTogglePassword("confirm")}
              >
                {showConfirmPassword ? (
                  <FontAwesomeIcon icon={faEye} />
                ) : (
                  <FontAwesomeIcon icon={faEyeSlash} />
                )}
              </span>
            </div>
            {error && (
              <div className="text-red-500 mb-4">
                <p>{error}</p>
              </div>
            )}
            <button
              disabled={isDisabled ? true : false}
              className="py-2 px-4 border border-emerald-500 bg-emerald-700 rounded text-gray-200  justify-end"
            >
              {t("Submit")}
            </button>
          </form>
        </div>
      </PageContainer>
    </>
  );
};

export default ChangePassword;
